import { ApplicationInsights, DistributedTracingModes, ITelemetryItem } from '@microsoft/applicationinsights-web';

const appInsights = new ApplicationInsights({
	config: {
		connectionString: process.env.NEXT_PUBLIC_AZURE_APP_INSIGHTS_KEY,
		enableAutoRouteTracking: true,
		enableCorsCorrelation: true,
		enableRequestHeaderTracking: true,
		enableResponseHeaderTracking: true,
		distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
		disableFetchTracking: false,
		disableAjaxTracking: false,
	},
});

appInsights.addTelemetryInitializer((envelope: ITelemetryItem) => {
	envelope.tags = envelope.tags || [];
	envelope.tags.push({ 'ai.cloud.role': process.env.NEXT_PUBLIC_AZURE_APP_INSIGHTS_CLOUD_ROLE });
});

export { appInsights as default };
